import request from '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export const login = (data, params = {}) => {
  const new_params = { ...getParameter(), ...params }
  return request.post(getBaseUrl() + "/customer/auth/login", data, { params: new_params });
};

export function registerApi(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.post(getBaseUrl() + "/customer/auth/pre-register", data, { params: new_params });
}

export function registerV2(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.post(getBaseUrl() + "/customer/auth/registerv2", data, { params: new_params });
}

export const customerData = (params = {}) => {
  const new_params = { ...getParameter(), ...params }
  return request.get(getBaseUrl() + "/customer", { params: new_params });
};

export function verification(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.post(getBaseUrl() + "/customer/auth/verification", data, { params: new_params });
}

export function sendOtp(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.post(getBaseUrl() + "/customer/auth/otp-resend", data, {
    params,
  });
}

export function changePhoneAuth(id, data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.post(getBaseUrl() + "/customer/auth/chengephone/" + id, data, {
    params,
  });
}

export function forgotPass(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.post(getBaseUrl() + "/customer/auth/forgotpassword", data, { params: new_params });
}

export function validOtp(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.post('/customer/auth/validotp', data, { params: new_params })
}

export function changePassAuth(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return request.put('/customer/auth/forgotpassword/changepassword', data, { params: new_params })
}